module.exports = { "default": require("core-js/library/fn/object/get-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// D:/midea_porject/php/htdocs/~/babel-runtime/core-js/object/get-prototype-of.js
// module id = 40
// module chunks = 0